import { DialogTitle, IconButton, Box } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import './../assets/styles/TableModalStyles.css';

const DialogHeader = ({ title, onClose }) => {
  return (
    <DialogTitle
      className="custom-dialog-title"
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box>{title}</Box>

      {onClose && (
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: 'absolute',
            right: 16,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 34,
            height: 34,
            color: 'rgba(255,255,255,0.85)',

            background: 'rgba(255,255,255,0.12)',
            backdropFilter: 'blur(6px)',

            '&:hover': {
              background: 'rgba(255,255,255,0.22)',
              color: '#fff'
            }
          }}
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      )}
    </DialogTitle>
  );
};

export default DialogHeader;
